import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { UserService } from '../../services/UserService';
import { Message } from 'primeng/api/message';
import { AlertService } from 'src/app/services/AlertService';
import { AccountService } from '../../services/AccountService';
import { utility } from 'src/app/common/utility';
@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss']
})
export class UserViewComponent implements OnInit {
    msgs: Message[];
    user: any;
    defaultMember: any;
    vCardUrl: any;
    canEditProfile: boolean = false;
    userSpecialties: string = "";

    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private breadcrumbService: AppBreadcrumbService,
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService) { }

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
            this.user = this.activatedRoute.snapshot.data['user'];
            this.user.ProfilePicture = 'data:image/png;base64,' + this.user.ProfilePicture;
                       
            this.vCardUrl = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(this.user.VCard);
            this.accountService.CanEditProfile(this.user.Id).subscribe(canEdit => {
                this.canEditProfile = canEdit;
            });

            if (this.user.Specialties != null) {
                this.userSpecialties = this.user.Specialties.map(a => a.Name)
            }  
            this.defaultMember = this.user.Members.find(m => m.IsDefaultMember == true)?.Member || null;        
            this.breadcrumbService.setItems([               
                { label: 'Broker #' + this.user.Id, routerLink: [] }
            ]);
        });     
    }

    downloadVCard() {
        document.location.href = this.vCardUrl;
    }

    UpdateUserFavorite() {
        this.userService.UpdateUserFavorite(this.user).subscribe(
            result => {
                if (result) {
                    var newFavStatus = !this.user.IsFavorite;
                    this.user.IsFavorite = newFavStatus;
                }
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while Update Favorite');
            }
        );
    }

    PrintProfilePDF() {
        this.userService.PrintProfilePDF(this.user.Id);
    }
    formatUrl(url:any)
    {
        return utility.formatUrl(url);
    }
    
    formatUrlforDisplay(url:any)
    {
        return utility.formatURLForDisplay(url);   
    }
}
